import VueRouter from 'vue-router';
import Vue from 'vue';


import SlideSize from './components/pages/slide-1-size.vue';
import SlideStyle from './components/pages/slide-2-style.vue';
import SlideFuel from './components/pages/slide-3-fuel.vue';
import SlideFunc from './components/pages/slide-4-func.vue';
import SlideResults from './components/pages/slide-5-results.vue';
import SlideCooker from './components/pages/slide-6-cooker.vue';

import Options from './components/pages/page-options.vue';
import PageStart from './components/pages/page-start.vue';
import SearchChrome from './components/pages/page-search.vue';

import Precache from './components/pages/page-precache.vue';
import TestPrecache from './components/pages/page-precache-test.vue';

Vue.use(VueRouter);
export default new VueRouter({
    routes: [
        { name: 'start',    path: '/', component: PageStart },

        { name: 'search',   path: '/search', component: SearchChrome,
            children: [
                { meta: { step: 1 }, name: 'size',     path: '', component: SlideSize },
                { meta: { step: 2 }, name: 'style',    path: 'size-:size', components: {
                    default: SlideStyle,
                    footer: { template: '<p>There is a Rangemaster cooker to suit all types of kitchen</p>' }
                }
                },
                { meta: { step: 3 }, name: 'fuel',     path: 'size-:size/style-:style', component: SlideFuel },
                { meta: { step: 4 }, name: 'function', path: 'size-:size/style-:style/fuel-:fuel', component: SlideFunc },
                { meta: { step: 5 }, name: 'results',  path: 'size-:size/style-:style/fuel-:fuel/type-:function', components: {
                    default: SlideResults,
                    footer: { template: '<p>{{$route.params.size}} cm, {{$route.params.style}}, {{$route.params.fuel}}, {{$route.params.function}} cooker</p>' }
                } 
                },
                { meta: { step: 6 }, name: 'cooker',   path: 'size-:size/style-:style/fuel-:fuel/type-:function/cooker-:cooker', component: SlideCooker }
            ] 
        },

        
        { name: 'options',  path: '/options', component: Options },
        { name: 'precache', path: '/first-run', component: Precache },

        { name: 'test-precache', path: '/test', component: TestPrecache }
    ]
})


// WEBPACK FOOTER //
// ./src/router.js